module.exports = function(app) {
	'use strict';

	app.controller('pages.employee.add.subscriber', ['$state', '$scope', '$q', 'employee', 'addFlowCommander', 'services', 'modal','sessionData','$filter',
		function($state, $scope, $q, employee, addFlowCommander, services, modal,sessionData,$filter) {

			if ($state.previous && $state.previous.name && $state.previous.name.indexOf('add') < 0) {
				addFlowCommander.sidebar.reset();
			}
            $scope.aemMode = false;
			if(window.location.href.indexOf('https://aem') != -1){
				$scope.aemMode = true;
			}
			$scope.employee = employee;
			$scope.commander = addFlowCommander;
           if(sessionData.appConfig && sessionData.appConfig.SEP) {
               $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
               //sessionData.appConfig.SEP.booleanValue;
           }
           else {
               $scope.hasSEP = false;
		   }
            $scope.outSideOpen = false;
            if($scope.hasSEP) {
                services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                    function (response) {
						if (response) {
							$scope.outSideOpen = response;
						}

                    });
                services.eprsvc.lifeEventRules().getLifeEventRules().then(
                    function (response) {
                        if (response && response.data && response.data.payload) {
                            $scope.lifeEventValues = response.data.payload;
                        }
                    }
                );
            }

			if ( $state.params.umi ) {
				employee.loadSummary( $state.params.umi ).then(
					function() {
						if ($state.params.reinstateDate) {
							$scope.validateSSN = function() { return $q.when(); };

							[employee.data.subscriber].concat(employee.data.dependents).forEach(function(participant) {
								if (participant.medicareEligibleIndicator !== 'yes') {
									delete participant.medicareEligible;
								}
								delete participant.otherInsurance;
								participant.otherInsuranceIndicator = 'unknown';
							});

							employee.data.globalCoverageEffectiveDate = $state.params.reinstateDate;

							if (employee.data.subscriber && employee.data.subscriber.memberCoverages && employee.data.subscriber.memberCoverages.splice) {
								employee.data.subscriber.memberCoverages.splice(0,999);
							}
							if (employee.data.dependents && employee.data.dependents.forEach) {
								employee.data.dependents.forEach(function(dep) {
									if (dep.memberCoverages && dep.memberCoverages.splice) {
										dep.memberCoverages.splice(0,999);
									}
								});
							}
						}
					}
				);
			}
			else {
				employee.loadEnrollment( $state.params.subscriberSSN );

				$scope.validateSSN = function() {
                    [$scope.employee.data.subscriber].concat($scope.employee.data.dependents).forEach(function(participant) {
                        if (participant.medicareEligibleIndicator !== 'yes') {
                            delete participant.medicareEligible;
                        }
                        if (participant.otherInsuranceIndicator !== 'yes') {
                            delete participant.otherInsurance;
                        }
                    });

                    var deferred = $q.defer();

					var handleExistingSSN = function(response) {
						employee.isLoading = false;

						if (
							response && response.data && response.data.payload &&
							response.data.payload.subscriber &&
							Array.isArray(response.data.payload.subscriber.memberCoverages)
						) {
							var memberCoverages = response.data.payload.subscriber.memberCoverages;
							var isActive = false;
							var umi = response.data.payload.umi;

							outer:
							for (var i = 0; i < memberCoverages.length; ++i) {
								var coverage = memberCoverages[i];
								if (coverage && coverage.memberLobs) {
									for (var j = 0; j < coverage.memberLobs.length; ++j) {
										var cancelReasonCode = coverage.memberLobs[j].cancelReasonCode;
										if (!(cancelReasonCode && cancelReasonCode.length)) { // something is NOT cancelled
											isActive = true;
											break outer;
										}
									}
								}
							}

							var modalScope = $scope.$new();
							modalScope.isActive = isActive;

							modalScope.doTheOK = function() {
								if (modalScope.isActive) {
									deferred.reject(function() { $state.go('employee.find.review', { umi: umi, edit: true }); });
								}
								else {
									deferred.resolve();
								}
							};

							modalScope.cancel = function() { deferred.reject(function() { $state.go('home'); }); };

							modal.open({
								scope: modalScope,
								template: require('pages/employee/modals/validateSSN.html'),
								classes: "epr-standard-modal large-modal"
							});
						}
					};

					employee.isLoading = true;
                    var params = {
                        ssn:  employee.data.subscriber.ssn,
                        firstName: employee.data.subscriber.fullName.first,
                        lastName:  employee.data.subscriber.fullName.last,
                        gender: employee.data.subscriber.gender,
                        dateOfBirth: $filter('date')(employee.data.subscriber.birthDate, 'MM/dd/yyyy')

                    }

					services.eprsvc.validateSSN().getData(params).then(
						function(response) {
                            if (
                                response && response.data && response.data.payload &&
                                response.data.payload.subscriber &&
                                Array.isArray(response.data.payload.subscriber.memberCoverages)
                            ){ handleExistingSSN(response);
                                employee.isLoading = false;}
							else{
                                employee.isLoading = false;
                                deferred.resolve(response);
                            }


						},
                        function(error){
                            employee.isLoading = false;
                            if (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription === 'EMPLOYEE-DETAILS-FRAUD') {
                                deferred.reject(function() {
                                    var modalScope = $scope.$new();
                                    modal.open({
                                                   scope: modalScope,
                                                   templateUrl: "_modals/ssnFraud.employerTemplate.html/pages/employee/modals/ssnFraud",
												   classes: "epr-standard-modal large-modal"
                                               });
								});
							}
							else {
                                deferred.resolve();
							}
                        }
					);

					return deferred.promise;
				};
			}

		}
	]);
};
